import React from 'react';
import { useSwiper } from 'swiper/react';
import LightBoxButton from '../Lightbox/LightBoxButton';
const SwiperNavButtons = () => {
    const swiper = useSwiper();
    return (React.createElement("div", { className: "nav-btns" },
        React.createElement("button", { className: "swiper-button-prev rounded-full focus-visible:outline32 outline-gray-50", onClick: () => swiper.slidePrev() },
            React.createElement(LightBoxButton, { direction: "left" })),
        React.createElement("button", { className: "swiper-button-next rounded-full focus-visible:outline-3 outline-gray-50", onClick: () => swiper.slideNext() },
            React.createElement(LightBoxButton, { direction: "right" }))));
};
export default SwiperNavButtons;
